import { getRecommendedPackages } from '../../utils';

export const SubscriptionOptionController = [
  '$scope', 'deviceService', 'placingTermsApi',
  function ($scope, deviceService, placingTermsApi) {
    $scope.isMobile = deviceService.isMobile;

    $scope.isSelected = () => placingTermsApi.isSelected(this.option);
    $scope.getRecommendedPackage = () => getRecommendedPackages(this.option)[0] || {};
  },
];
